module.exports = __webpack_public_path__ + "img/role_5_name.2e7bb70f.png";